module.exports = __webpack_public_path__ + "assets/img/station13.85f02cc1.png";